import React, { Component } from 'react';

const formatTimer = (h, m, s) => {
  const hours = h > 9 ? h : `0${h}`;
  const minutes = m > 9 ? m : `0${m}`;
  const seconds = s > 9
    ? s
    : s < -9
      ? `${s*-1}`
      : s >= -9 && s < 0
        ? `0${s*-1}`
        : `0${s}`;
  return `${hours}:${minutes}:${seconds}`;
};

class Stopwatch extends Component {
  constructor(props) {
    super(props);

    const formatted = formatTimer(0, 0, 0);

    this.state = {
      hours: 0,
      minutes: 0,
      seconds: 0,
      formatted,
    };
  }

  componentWillUnmount() {
    this.stop();
  }

  componentDidMount() {
    if (this.props.start && this.props.startTime) {
      this.start(this.props.startTime);
    }
  }

  componentWillReceiveProps(props, nextContext) {
    if (props.restart && !this.props.restart) {
      this.restart();
    }

    if (props.start && !this.props.start) {
      this.start();
    }

    if (props.stop && !this.props.stop) {
      this.stop();
      this.clear();
    }
  }

  start = (startTime = 0) => {
    if (!startTime && this.props.delay > 0 && this.props.delay < 59) {
      this.setState(prevState => ({
        seconds: prevState.seconds - this.props.delay,
      }));
    } else if (startTime) {
      const minutes = Math.floor(startTime / 60);
      const hours = Math.floor(minutes / 60);
      this.setState(() => ({
        seconds: minutes ? startTime - (minutes * 60) : startTime,
        minutes: minutes < 60 ? minutes : minutes - (hours * 60),
        hours,
      }));
    }
    this.interval = setInterval(this.counter, 1000);
  };

  stop = () => {
    clearInterval(this.interval);
  };

  clear = (cb = () => {}) => {
    const formatted = formatTimer(0, 0, 0);
    this.setState({
      seconds: 0,
      minutes: 0,
      hours: 0,
      formatted,
    }, cb);
  };

  restart = () => {
    this.stop();
    this.clear(this.start);
  };

  counter = () => {
    const { hours, minutes, seconds } = this.state;
    const { onChange } = this.props;

    this.setState(prevState => ({
      seconds: prevState.seconds + 1,
      formatted: formatTimer(hours, minutes, prevState.seconds + 1),
    }));
    if (seconds === 59) {
      this.setState(prevState => ({
        seconds: 0,
        minutes: prevState.minutes + 1,
        formatted: formatTimer(hours, prevState.minutes + 1, 0),
      }));
      if (minutes === 59) {
        this.setState(prevState => ({
          minutes: 0,
          hours: prevState.hours + 1,
          formatted: formatTimer(prevState.hours + 1, 0, seconds),
        }));
      }
    }

    if (onChange) {
      onChange(this.state);
    }
  };

  render() {
    const { seconds, minutes, hours } = this.state;
    const { hideIcon, countdown } = this.props;
    const sign = seconds < 0 ? 'minus' : seconds > 0 ? 'plus' : 'zero';
    const formatted = formatTimer(hours, minutes, seconds);

    return (
      <span className={`seconds-counter seconds-counter-${sign}`}>
        { !hideIcon && <i className="fa fa-clock-o hidden-xs"/> }
        {' '}
        { countdown ? seconds*-1 : formatted }
      </span>
    );
  }
}

export default Stopwatch;
